import React from "react";

interface SendQuotationIconProps {
  className?: string;
  style?: React.CSSProperties;
  size?: number;
  color?: string;
}

const SendQuotationIcon: React.FC<SendQuotationIconProps> = ({
  className,
  style,
  size = 16,
  color = "currentColor",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{
      fill: "none",
      ...style,
    }}
  >
    <path
      d="M16.5 1.37891L8.25 9.62891M16.5 1.37891L11.25 16.3789L8.25 9.62891M16.5 1.37891L1.5 6.62891L8.25 9.62891"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default SendQuotationIcon;
